module.exports = require("app-lib-trans-storage");